module.exports = __webpack_public_path__ + "img/demo-initialization.234cc622.png";